import { Skeleton } from '@crehana/compass.ui';

export const GeneralInformationSkeleton = () => {
  return (
    <div
      className="tw-w-full tw-px-3.2 md:tw-px-[9.2rem] lg:tw-px-[32.4rem] tw-pt-4 md:tw-pt-4.8"
      style={{
        background:
          'linear-gradient(90deg, #F2F3F5 0%, rgba(240, 242, 255, 0.90) 100%)',
      }}
    >
      <div className="tw-flex tw-w-full tw-flex-col tw-items-center">
        <Skeleton animated className="tw-h-2.4 tw-w-[20%] tw-rounded-0.8" />
        <Skeleton
          animated
          className="tw-h-2.4 tw-w-[30%] tw-rounded-0.8 tw-mt-1.2"
        />
      </div>

      <div className="tw-flex tw-w-full tw-flex-col tw-items-start tw-mt-5.6">
        <Skeleton animated className="tw-h-2.4 tw-w-[40%] tw-rounded-0.8 " />
        <Skeleton
          animated
          className="tw-h-4 tw-w-full tw-rounded-0.8 tw-mt-1.2"
        />
        <Skeleton
          animated
          className="tw-h-2.4 tw-w-[40%] tw-rounded-0.8 tw-mt-3.2"
        />
        <Skeleton
          animated
          className="tw-h-4 tw-w-full tw-rounded-0.8 tw-mt-1.2"
        />
        <Skeleton
          animated
          className="tw-h-2.4 tw-w-[40%] tw-rounded-0.8 tw-mt-3.2"
        />
        <Skeleton
          animated
          className="tw-h-4 tw-w-full tw-rounded-0.8 tw-mt-1.2"
        />
        <Skeleton
          animated
          className="tw-h-2.4 tw-w-[40%] tw-rounded-0.8 tw-mt-3.2"
        />
        <Skeleton
          animated
          className="tw-h-4 tw-w-full tw-rounded-0.8 tw-mt-1.2"
        />
        <Skeleton
          animated
          className="tw-h-2.4 tw-w-[40%] tw-rounded-0.8 tw-mt-3.2"
        />
        <Skeleton
          animated
          className="tw-h-4 tw-w-full tw-rounded-0.8 tw-mt-1.2"
        />
      </div>
    </div>
  );
};
